import { render, staticRenderFns } from "./overviewCard.vue?vue&type=template&id=1deb54a0&"
import script from "./overviewCard.vue?vue&type=script&lang=js&"
export * from "./overviewCard.vue?vue&type=script&lang=js&"
import style0 from "./overviewCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports